export default "__VITE_ASSET__cdf91b06__"